import api from '@/api/api';

export default {
    obterFormulario(tipoId) {
        return api.get(route('solicitacoes-atendimento.tipos.formulario', { tipoId }));
    },

    criar(data) {
        return api.post(route('solicitacoes-atendimento.nova'), data);
    },

    verificarAtendimento(tipoProcesso) {
        return api.get(route('solicitacoes-atendimento.verificar'), {
            params: { tipo_processo: tipoProcesso }
        });
    },

    listarSolicitacoes(params = {}) {
        return api.get(route('solicitacoes-atendimento'), { params });
    },

    consultarProcesso() {
        return api.get(route('solicitacoes-atendimento.processo'));
    },

    obterAtendimento(atendimentoId) {
        return api.get(route('solicitacoes-atendimento.atendimento', atendimentoId));
    },

    listarTiposDocumentos(tipoId) {
        return api.get(route('solicitacoes-atendimento.tipos.documentos', { tipoId }));
    },

    obterMenu(personaId) {
        return api.get(route('solicitacoes-atendimento.menu', personaId));
    }
};
